import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { CircularProgress, IconButton, Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import * as Sentry from '@sentry/react';
import AuthedHome from './AuthedHome';
import Version from './Version';
import NavBar from '../components/NavBar';
import ConnectorPage from './ConnectorPage';
import { useUser } from '../contexts/UserContext';
import InvestorProfilePage from './investor/InvestorProfilePage';
import { EntrepreneurTutorial } from './entrepreneur/EntrepreneurTutorial';
import { Footer } from '../components/Footer';
import EntrepreneurPageRouter from './EntrepreneurPageRouter';
import { useAlert } from '../contexts/AlertContext';
import ErrorView from './ErrorView';

export default function AuthedContainer() {
  const { loading } = useUser();
  const { message: alertMessage, cleanupAlert } = useAlert();

  if (loading) {
    return (
      <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <Router>
      <NavBar />
      <Sentry.ErrorBoundary fallback={<ErrorView />}>
        <Switch>
          <Route exact path='/' component={AuthedHome} />
          <Route path='/version' component={Version} />
          <Route path='/entrepreneur/tutorial' component={EntrepreneurTutorial} />
          <Route path='/entrepreneur/:profileId' component={EntrepreneurPageRouter} />
          <Route path='/investor/:profileId' component={InvestorProfilePage} />
          <Route path='/connector' component={ConnectorPage} />
        </Switch>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={!!alertMessage}
          autoHideDuration={6000}
          message={alertMessage}
          action={(
            <>
              <IconButton size='small' aria-label='close' color='inherit' onClick={() => { cleanupAlert(); }}>
                <CloseIcon fontSize='small' />
              </IconButton>
            </>
          )}
        />
      </Sentry.ErrorBoundary>
      <Footer />
    </Router>
  );
}
